import { render } from "./NewsList.vue?vue&type=template&id=360e3328"
import script from "./NewsList.vue?vue&type=script&lang=ts"
export * from "./NewsList.vue?vue&type=script&lang=ts"
script.render = render

export default script